import { useContext } from 'react';

import { ChoiceListContext } from './ChoiceList';

export const useChoiceListContext = () => {
    const value = useContext(ChoiceListContext);

    if (value === undefined) {
        throw new Error('useChoiceListContext must be used within ChoiceListContext.Provider');
    }

    return value;
};
